import groq from 'groq'

import { callToAction } from './callToAction.js'
import { socials } from './socials.js'

export function footer() {
	return groq`
 *[_type == 'sharedContent'][0] {
  ...footer {
    title,
    ctas[]{...${callToAction()}},
    secondaryPages[]{...${callToAction()}},
    "legalPages": legalPages[]{
      _key,
      "type": page[0]._type,
      "title": select(page[0]._type == 'external' => label, page[0]->metadata.title),
      "slug": page[0]->metadata.slug.current,
      "url": page[0].url,
    },
    certificates[],
  },
  ...${socials()}
},
`
}
